import React, {memo, useCallback, useState, useMemo, useEffect} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {useLocalization} from "../../../../hooks/localization"
import {AlarmLogs} from "../../../../store/control/state"
import {useRPC} from "../../../../hooks/rpc"

function convertToDate(timestamp: number) {
    const dateObject = new Date(timestamp * 1000)
    let y = dateObject.getFullYear().toString()
    if (y.length === 1) {
        y = "0" + y
    }
    let m = (dateObject.getMonth() + 1).toString()
    if (m.length === 1) {
        m = "0" + m
    }
    let d = dateObject.getDate().toString()
    if (d.length === 1) {
        d = "0" + d
    }
    let h = dateObject.getHours().toString()
    if (h.length === 1) {
        h = "0" + h
    }
    let mi = dateObject.getMinutes().toString()
    if (mi.length === 1) {
        mi = "0" + mi
    }
    return `${d}/${m}/${y} ${h}:${mi}`
}

const keyExtractor = (item: AlarmLogs) => item.id.toString()
const logCount = 50
export const AlarmLogsScreen = memo(function AlarmLogsScreen() {
    const [rpc] = useRPC()
    const {t} = useLocalization()
    const [alarmData, setAlarmData] = useState<AlarmLogs[]>([])
    const [selectedControl, setSelectedControl] = useState<AlarmLogs>(null)

    const onPressRefresh = useCallback(() => {
        rpc.getAlarmLog(logCount).then(data => setAlarmData(data))
    }, [rpc])

    useEffect(() => onPressRefresh(), [onPressRefresh])

    const newList = useMemo(
        () =>
            alarmData
                .map(r => {
                    return {
                        id: r?.id,
                        icon_type: r?.icon_type,
                        input_id: r?.input_id,
                        message: r?.message,
                        sensor_type_id: r?.sensor_type_id,
                        timestamp: r?.timestamp,
                        time: convertToDate(r?.timestamp)
                    }
                })
                .sort((a, b) => (a?.id > b?.id ? 1 : -1)),
        [alarmData]
    )

    const displayNameExtractor = useCallback((item: AlarmLogs, column: ColumnModel) => {
        if (column.key === "name") {
            return item
        }
        return item[column.key] || "-"
    }, [])

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 2,
                name: "ID",
                key: "id"
            },
            {
                length: 2,
                name: t("time"),
                key: "time"
            },
            {
                length: 3,
                name: t("message"),
                key: "message"
            }
        ],
        [t]
    )

    const buttons = useMemo(
        () => [
            {
                text: t("refresh"),
                onClick: onPressRefresh,
                className: "green"
            }
        ],
        [t, onPressRefresh]
    )

    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer
                className="service-edit"
                buttons={buttons}
                backUrl="/settings/logs"
                searchable={true}
            >
                <SettingsList
                    columns={columns}
                    items={newList}
                    keyExtractor={keyExtractor}
                    displayNameExtractor={displayNameExtractor}
                    selectedItem={selectedControl}
                    onItemSelected={setSelectedControl}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
